import React from 'react'

import { DiscountChip } from '@Components/Chips/DiscountChip'
import { FreeDeliveryChip } from '@Components/Chips/FreeDeliveryChip'
import { NewChip } from '@Components/Chips/NewChip'
import { TwoForOneChip } from '@Components/Chips/TwoForOneChip'
import { ChipOptions } from '@Components/Product/Display/Helpers/ChipAssets'
import { ProductChipsWrapper } from '@Components/Product/Display/styledElements'

interface Props {
  options: ChipOptions
}

const ProductChipsLayout = ({ options }: Props) => {
  const { freeDelivery, isNew, price, productType, showChips } = options
  if (!showChips) {
    return null
  }
  return (
    <ProductChipsWrapper>
      {productType === 'glasses' && <TwoForOneChip />}
      {price?.discount && (
        <DiscountChip
          discount={{
            percentage: price.discount.percent || 0,
            context: price.discount.code?.context || '',
          }}
          size="small"
        />
      )}
      {isNew && <NewChip size="small" />}
      {freeDelivery && <FreeDeliveryChip size="small" />}
    </ProductChipsWrapper>
  )
}

export default ProductChipsLayout
